module.exports = __webpack_public_path__ + "static/img/gwba.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beian/gwba.png
// module id = 3Nh0
// module chunks = 4